import { render, staticRenderFns } from "./BillingState.vue?vue&type=template&id=28380f42&scoped=true"
import script from "./BillingState.vue?vue&type=script&lang=js"
export * from "./BillingState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28380f42",
  null
  
)

export default component.exports